import { AccountRange } from '../../shared-types'

const getAccountNumberParts = (number: string | undefined): string[] => {
  if (!number) {
    return []
  }
  return number.split('.')
}

const getAccountRangeAndPostfix = (
  number: string | undefined
): [AccountRange, string | undefined] | [] => {
  const parts = getAccountNumberParts(number)

  if (parts.length === 0) {
    return []
  }

  if (parts.length === 1) {
    return [parts[0], undefined]
  }

  if (parts.length > 1) {
    const accountRange = parts.slice(0, -1).join('.')
    const postfix = parts[parts.length - 1]

    return [accountRange, postfix]
  }

  return []
}

export { getAccountNumberParts, getAccountRangeAndPostfix }
